import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  invoicePicklistReportFetch: ['criteria', 'sorts', 'pageSize', 'page', 'formikBag'],

  invoicePicklistReportFetchSuccess: ['criteria', 'sorts', 'reportData', 'pagination'],

  invoicePicklistReportLoading: ['boolean'],

  invoicePicklistReportExport: ['criteria'],
  invoicePicklistReportExportLoading: ['boolean']
});

export const InvoicePicklistReportTypes = Types;

export default Creators;
